module.exports = __webpack_public_path__ + "static/media/account-image-2.a41ce00e.jpg";